import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";
import { EventBus } from "../../../eventbus";

export default {
  props: {
    parentId: String,
    actions: { type: Array, default: () => [] },
  },
  components: {
    popper: Popper,
  },

  methods: {
    sendStatus(status) {
      if (this.parentId) {
        EventBus.$emit(`item-actions--${status ? "open" : "closed"}`, {
          id: this.parentId,
        });
      }
    },
    closePopper(func = false) {
      //close popper
      if (this.$refs.trigger) {
        this.$refs.trigger.click();
      }

      //preform function
      if (func) {
        func();
      }

      this.sendStatus(false);
    },
  },
  watch: {
    actions() {},
  },
};
